module.exports = __webpack_public_path__ + "static/img/3791_phase_function_Paper_PointsHejduk_Prediction.156ce26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3791_phase_function_Paper_PointsHejduk_Prediction.png
// module id = EhNF
// module chunks = 0